import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import cn from 'classnames'
import { AudioContext } from 'rewact'
import { QUERY } from '../../apollo'
import { RequestForm } from './SupervisionModal'
import LogoPixedenMusic from '../LogoPixedenMusic'
import TrackContext from '../../context/TrackContext'
import * as Icon from '../Icons'
import { useDelayedState } from '../../hooks'

import styles from './modal.module.css'

function Quote({ selectionState, closeModal }) {
  const { setPlayerTrack, playerTrack } = useContext(TrackContext)
  const { play, isPaused, pause, time, duration } = useContext(AudioContext)
  const { data } = useQuery(QUERY.CURRENT_USER)
  const currentUser = data?.currentUser
  let history = useHistory()
  const [isReallyPaused] = useDelayedState(
    isPaused,
    process.env.NODE_ENV === 'production' ? 300 : 100
  )
  const m = '0' + Math.round(((duration - time) / 60) % 60)
  const s = '0' + Math.round((duration - time) % 60)
  return (
    <div className={styles.wrapper}>
      <div className={styles.containerOut}>
        <LogoPixedenMusic className={styles.logoPixedenMusic} />
        <div className={styles.contentWrapper}>
          <div className={styles.sidebar}>
            <p className={styles.textBig}>
              Pre-cleared premium quality music tracks for sync licensing.
            </p>
            <div className={styles.plyerGrid}>
              {Object.keys(selectionState).map((track) => {
                const { slug, name, artist, image, id, genre } =
                  selectionState[track]

                const active = !isReallyPaused && slug === playerTrack.slug
                return (
                  <div
                    className={cn(styles.playerItem, {
                      [styles.active]: active,
                    })}
                    key={slug}
                    title={`"${name}" by ${artist}`}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      if (!active) {
                        setPlayerTrack({
                          id,
                          artist,
                          name,
                          slug,
                          image,
                        })
                        setTimeout(() => play(), 100)
                      } else {
                        if (isReallyPaused) {
                          play()
                        } else {
                          pause()
                        }
                      }
                    }}
                  >
                    {image ? (
                      <img
                        alt="Cover"
                        className={styles.playerItemImg}
                        src={
                          image.startsWith('/')
                            ? image
                            : `${process.env.REACT_APP_COVER_URI}/m/${image}`
                        }
                      />
                    ) : (
                      <div className={styles.playerItemImg}>
                        <Icon.Placeholder
                          style={{ color: '#ff3b57', transform: 'scale(0.7)' }}
                        />
                      </div>
                    )}
                    <div className={styles.playerItemDetails}>
                      <p className={styles.playerItemName}>{name}</p>
                      <p className={styles.playerItemArtist}>{artist}</p>
                      {genre ? (
                        <p className={styles.playerItemGenre}>
                          {genre.join(', ')}
                        </p>
                      ) : null}
                    </div>

                    <div
                      className={cn(styles.playerItemTime, {
                        [styles.visible]: active,
                      })}
                    >
                      {active ? `${m.substr(-2)}:${s.substr(-2)}` : '00:00'}
                    </div>

                    <div
                      className={cn(styles.playerItemBtn, {
                        [styles.visible]: active,
                      })}
                    >
                      {active ? (
                        <Icon.Pause />
                      ) : (
                        <Icon.Play
                          style={{
                            marginLeft: 2,
                            marginTop: 1,
                            width: 15,
                            height: 17,
                          }}
                        />
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div className={styles.mainSide}>
            <p className={styles.textSmall}>
              Get a same day quote for your project from our professional music
              team. <br />
              Let us know a few details first.
            </p>

            <RequestForm
              requestType="quote"
              recaptcha={true}
              initialValues={{
                ...(currentUser
                  ? { email: currentUser.email, name: currentUser.name }
                  : {}),
              }}
              extraValues={{
                tracks: Object.keys(selectionState).map((track) => {
                  const { slug, artist, name, image } = selectionState[track]
                  return { slug, artist, name, image }
                }),
              }}
              callback={({ requestType, requestId }) => {
                setTimeout(() => {
                  closeModal()
                  history.push(`/profile/${requestType}/${requestId}`)
                }, 2000)
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quote
